module.exports = __webpack_public_path__ + "static/media/msft_hack_badge.fbe58545.png";